import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/customer-contracts'
)({
  meta: () => [{ title: MENU.CUSTOMER_CONTRACT }]
})
